import { Confirmation } from "@jewlr/storybook/modal"
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate, useNavigationType } from "react-router-dom"

import {
  doLogout,
  deactivateAccountMenu,
  setHeaderDropdown,
} from "app-store-v2/app/actions"

const LogoutModal = () => {
  const [show, setShow] = useState(false)
  const mounted = useRef(false)

  const location = useLocation()
  const navigate = useNavigate()
  const action = useNavigationType()

  const dispatch = useDispatch()
  const handleLogout = useCallback(() => {
    dispatch(setHeaderDropdown(""))
    dispatch(deactivateAccountMenu())
    dispatch(doLogout())
  }, [])

  const hideModal = useCallback(() => {
    const path = `${location.pathname}${location.search}`
    navigate(path, { replace: action !== "PUSH" })
  }, [action, location.pathname, location.search])

  useEffect(() => {
    mounted.current = true
    return () => (mounted.current = false)
  }, [])

  useEffect(() => {
    if (mounted.current) {
      setShow(location.hash === "#logout")
    }
  }, [location.hash])

  useLayoutEffect(() => {
    if (location.hash === "#logout") {
      hideModal()
    }
  }, [])

  return (
    <Confirmation
      cancelText="Cancel"
      confirmText="Yes"
      description="Are you sure you want to logout?"
      onCancel={() => hideModal()}
      onConfirm={() => {
        handleLogout()
        hideModal()
      }}
      show={show}
      title="Logout"
    />
  )
}

export default LogoutModal
